import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import DopasujObudowe from '@/components/DopasujObudowe'
import DopasujCentrale from '@/components/DopasujCentrale'
import Zaplecze from '@/components/Zaplecze'
import CentralaLista from '@/components/CentralaLista'
import PowiazanieCentrali from '@/components/PowiazanieCentrali'
import ModulyLista from '@/components/ModulyLista'
import PowiazanieModuly from '@/components/PowiazanieModuly'
import ObudowyLista from '@/components/ObudowyLista'
import ProducenciLista from '@/components/ProducenciLista'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/dopasuj-obudowe',
      name: 'DopasujObudowe',
      component: DopasujObudowe
    },
    {
      path: '/dopasuj-centrale/',
      name: 'DopasujCentrale',
      component: DopasujCentrale,
      props: false
    },
    {
      path: '/dopasuj-centrale/:symbol',
      name: 'DopasujCentraleSymbol',
      component: DopasujCentrale,
      props: false
    },
    {
      path: '/zaplecze',
      name: 'Zaplecze',
      component: Zaplecze
    },
    {
      path: '/zaplecze/lista-centrala',
      name: 'CentralaLista',
      component: CentralaLista
    },
    {
      path: '/zaplecze/lista-moduly',
      name: 'ModulyLista',
      component: ModulyLista
    },
    {
      path: '/zaplecze/centrala-obudowa',
      name: 'PowiazanieCentrali',
      component: PowiazanieCentrali
    },
    {
      path: '/zaplecze/moduly-obudowa',
      name: 'PowiazanieModuly',
      component: PowiazanieModuly
    },
    {
      path: '/zaplecze/obudowy',
      name: 'ObudowyLista',
      component: ObudowyLista
    },
    {
      path: '/zaplecze/producenci',
      name: 'ProducenciLista',
      component: ProducenciLista
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js